<template>
  <div
    class="list-group-item-inner d-flex align-items-center justify-content-end"
  >
    <div class="preview-col d-flex align-items-center">
      <slot name="preview" />
    </div>
    <div class="d-inline-flex align-items-center justify-content-end">
      <slot name="first" />
    </div>
    <div class="flex-grow-1" ref="umr" v-b-tooltip.hover :title="truncated.umr ? $props.item.umr : ''">{{ $props.item.umr }}</div>
    <div class="rc-col bdx-col" ref="risk_code" v-b-tooltip.hover :title="truncated.risk_code ? $props.item.risk_code : ''">{{ $props.item.risk_code }}</div>
    <div class="cc-col bdx-col" ref="cat_code" v-b-tooltip.hover :title="truncated.cat_code ? $props.item.cat_code : ''">{{ $props.item.cat_code }}</div>
    <div class="sn-col bdx-col" ref="section_no" v-b-tooltip.hover :title="truncated.section_no ? $props.item.section_no : ''">{{ $props.item.section_no }}</div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { has } from 'lodash-es'

import { useTruncatedTooltip } from '@composables'

export default defineComponent({
  name: 'BDXMatchPendingManagerListItem',
  props: {
    item: {
      type: Object,
      required: true,
      validator: (value) =>
        ['id', 'umr', 'risk_code', 'cat_code', 'section_no'].every((item) =>
          has(value, item)
        )
    }
  },
  setup(props) {
    const { truncated, umr, risk_code, cat_code, section_no } = useTruncatedTooltip(
      ['umr', 'risk_code', 'cat_code', 'section_no'],
      () => props.item
    )

    return { truncated, umr, risk_code, cat_code, section_no }
  }
})
</script>

<style scoped>
.bdx-manager-list .list-group-item-inner > div {
  min-width: 50px;
}

.bdx-manager-list .list-group-item-inner > div.preview-col {
  min-width: 44px;
  width: 44px;
}

.bdx-manager-list .list-group-item-inner > div:nth-child(2) {
  min-width: 30px;
  margin-right: 6px;
}

.bdx-manager-list .list-group-item-inner > div.flex-grow-1,
.bdx-manager-list .list-group-item-inner > div.bdx-col {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bdx-manager-list .list-group-item-inner > div >>> .custom-checkbox {
  width: 20px;
  margin-left: 10px;
}

.bdx-manager-list .list-group-item-inner > div >>> .custom-checkbox > label {
  padding-left: 0;
  margin-bottom: 0;
}
</style>
